import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './VisibilidadeAgendamentosSection.css';

const VisibilidadeAgendamentosSection = () => {
  return (
    <section className="visibilidade-agendamentos-section">
      <div 
        className="visibilidade-agendamentos-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/cachorro-telefone.png)`,
        }}
      ></div>
      <div className="visibilidade-agendamentos-content">
        <div className="visibilidade-agendamentos-text">
          <h2 className="visibilidade-agendamentos-title">
            Mais visibilidade, mais agendamentos.
          </h2>
          <p className="visibilidade-agendamentos-subtitle">
            Conecte-se a uma base ativa de tutores que já procuram serviços de banho. A plataforma faz o marketing por você — sem investimento em anúncios.
          </p>
          
          <div className="visibilidade-cards">
            <div className="visibilidade-card">
              <div className="card-label">Custo de aquisição</div>
              <div className="card-value">Valor de repasse</div>
            </div>
            
            <div className="visibilidade-card">
              <div className="card-label">Novos clientes/mês</div>
              <div className="card-value number">+15</div>
            </div>
            
            <div className="visibilidade-card">
              <div className="card-label">Taxa de retorno</div>
              <div className="card-value number">78%</div>
            </div>
          </div>
          
          <div className="visibilidade-features">
            <div className="visibilidade-feature-item">
              <CheckCircleIcon className="feature-icon" />
              <span className="feature-text">Sem gastos com anúncios</span>
            </div>
            
            <div className="visibilidade-feature-item">
              <CheckCircleIcon className="feature-icon" />
              <span className="feature-text">Reputação digital crescente</span>
            </div>
            
            <div className="visibilidade-feature-item">
              <CheckCircleIcon className="feature-icon" />
              <span className="feature-text">Clientes recorrentes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisibilidadeAgendamentosSection;

